import { render, staticRenderFns } from "./Covid.vue?vue&type=template&id=536466d3"
import script from "./Covid.vue?vue&type=script&lang=js"
export * from "./Covid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536466d3')) {
      api.createRecord('536466d3', component.options)
    } else {
      api.reload('536466d3', component.options)
    }
    module.hot.accept("./Covid.vue?vue&type=template&id=536466d3", function () {
      api.rerender('536466d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/Covid.vue"
export default component.exports